/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";

type Placement = "top" | "bottom" | "start" | "end";

type WrapperProps = {
  placement: Placement;
};

const ControlWrapper = styled("div")`
  display: block;
`;

function handlePosition(props: WrapperProps): string {
  switch (props.placement) {
    case "start":
      return `
        label {
          margin-right: 1rem;
        }
      `;
    case "end":
      return `
        ${ControlWrapper} {
          flex-order: 0;
        }

        label {
          flex-order: 1;
          margin-left: 1rem;
        }
      `;
    case "top":
      return `
        flex-flow: column wrap;

        label {
          margin-bottom: 1rem;
        }
      `;
    case "bottom":
      return `
          flex-flow: column wrap;

          ${ControlWrapper} {
            flex-order: 0;
          }

          label {
            flex-order: 1;
            margin-top: 1rem;
          }
        `;
    default:
      return "";
  }
}

const Wrapper = styled("div")<WrapperProps>`
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  ${ControlWrapper} {
    div {
      max-width: 1rem;
    }
  }

  ${handlePosition};
`;

type Props = React.HTMLProps<HTMLLabelElement> & {
  label: string;
  control: React.ReactNode;
  labelPlacement: Placement;
};

export function FormControlLabel({
  label,
  labelPlacement,
  control,
  ...props
}: Props) {
  return (
    <Wrapper placement={labelPlacement}>
      <label {...props}>{label}</label>
      <ControlWrapper>{control}</ControlWrapper>
    </Wrapper>
  );
}
